import { render } from "./SharedFilesTable.vue?vue&type=template&id=6576a521&scoped=true"
import script from "./SharedFilesTable.vue?vue&type=script&lang=js"
export * from "./SharedFilesTable.vue?vue&type=script&lang=js"

import "./SharedFilesTable.vue?vue&type=style&index=0&id=6576a521&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6576a521"]])

export default __exports__